import type { ReactNode } from "react";

// Eyebrow-titled panel scaffold shared across the Settings sub-panels
// (Appearance, Model, …): a padded `.box bg-surface` with a small tracked
// eyebrow title and optional sub line above the content. Defined once so the
// panels can't drift; see ADR-0014.
export function SettingsCard({
  title,
  sub,
  children,
}: {
  title: string;
  sub?: string;
  children: ReactNode;
}) {
  return (
    <div className="box bg-surface p-6">
      <div className="text-[10px] tracking-[0.25em] text-ink/55">{title}</div>
      {sub ? <div className="mt-1 text-[12px] text-ink/55">{sub}</div> : null}
      <div className="mt-4">{children}</div>
    </div>
  );
}
